import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ColumnFiltersState } from "@tanstack/react-table";
import { Axios } from "api/axios";
import { api } from "helpers/api_url";

const API_URL = process.env.REACT_APP_BASE_URL;
const TOKEN = "a94c7ac0083ae190f0fe61143a7547799b5334c4";

const headers = {
  Authorization: `Token ${TOKEN}`,
  "Content-Type": "application/json",
};

export const fetchSubCategorys = createAsyncThunk(
  "subcategory/fetchSubCategorys",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search);
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }

    if (filters && filters.length > 0) {
      // params.append("filters", JSON.stringify(filters));
      filters.forEach(
        ({
          filterField,
          filterValue,
        }: {
          filterField: string;
          filterValue: any;
        }) => {
          if (
            filterField &&
            filterValue !== undefined &&
            filterValue !== null
          ) {
            if (typeof filterValue === "object" && filterValue !== null) {
                if (filterField === "created_at") {
                  if (filterValue.from_date) {
                    params.append("created_at_from", filterValue.from_date);
                  }
                  if (filterValue.to_date) {
                    params.append("created_at_to", filterValue.to_date);
                  }
                } else if (filterField === "updated_at") {
                  if (filterValue.from_date) {
                    params.append("updated_at_from", filterValue.from_date);
                  }
                  if (filterValue.to_date) {
                    params.append("updated_at_to", filterValue.to_date);
                  }
                } else {
                  // Handle other object filters
                  Object.entries(filterValue).forEach(([key, value]) => {
                    if (value !== undefined && value !== null && value !== "") {
                      params.append(key, String(value));
                    }
                  });
                }
              } else {
                // Handle primitive values (string, number)
                params.append(filterField, filterValue);
              }
          }
        }
      );
    }
    const response: any = await Axios.get(`${api.master.sub_category.list}?${params.toString()}`);

    return {
      data: response.data.data || [],
      rowCount: response.data.count || 0,
    };
  }
);

export const fetchSubCategoryById = createAsyncThunk(
  "subcategory/fetchById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.get(`${api.master.sub_category.fetchSubCategoryById}${id}`);

      return response.data.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch SubCategory by ID"
      );
    }
  }
);

export const fetchSubCategoryByDropDown = createAsyncThunk(
  "SubCategory/fetchByDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`${api.master.sub_category.fetchSubCategoryByDropDown}`);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch SubCategory list"
      );
    }
  }
);

// export const fetchSuCategoryBasedOnSelectedCategory = createAsyncThunk(
//   "district/fetchById",
//   async (id: string, { rejectWithValue }) => {
//     try {
//       const response = await Axios.get(`${API_URL}/district/${id}/get/`);
//       return response;
//     } catch (err: any) {
//       return rejectWithValue(
//         err.response?.data || "Failed to fetch SubCategory by ID"
//       );
//     }
//   }
// );


export const fetchSuCategoryBasedOnSelectedCategory = createAsyncThunk(
  "district/fetchById",
  async (category: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`${api.master.sub_category.fetchSuCategoryBasedOnSelectedCategory}${category}`);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch SubCategory by ID"
      );
    }
  }
);

// Fetch subcategories by category ID (for enquiry/item details forms)
export const fetchSubCategoryByCategoryId = createAsyncThunk(
  "SubCategory/fetchSubCategoryByCategoryId",
  async (categoryId: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`${api.master.sub_category.fetchSubCategoryByCategoryId}${categoryId}`);
      return response.data || [];
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch SubCategory list"
      );
    }
  }
);

// Fetch subcategories by category ID DROPDOWN (for enquiry/item details forms)
export const fetchSubCategoryDropdownByCategoryId = createAsyncThunk(
  "SubCategory/fetchSubCategoryDropdownByCategoryId",
  async (categoryId: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`${api.master.sub_category.fetchSubCategoryDropdownByCategoryId}/${categoryId}`);
      return response.data || [];
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch SubCategory list"
      );
    }
  }
);

export const updateSubCategory = createAsyncThunk(
  "subcategory/updateSubCategory",
  async ({id,data}:{id:any,data:any}, { rejectWithValue }) => {
    try {
      console.log(data)
      const response: any = await Axios.put(
        `${api.master.sub_category.updateSubCategory}${id}`,  
        data
      );
      return response;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to update SubCategory"
      );
    }
  }
);

export const updateStatusInSubCategory = createAsyncThunk(
  "subcategory/updateStatusInSubCategory",
  async (data: any) => {
    const payload = { is_active: data.is_active };
    const response: any = await Axios.patch(
      `${api.master.sub_category.updateStatusInSubCategory}${data.id}/`,
      payload
    );
    return response.data.data;
  }
);

export const addSubCategory = createAsyncThunk(
  "subcategory/addSubCategory",
  async (data: any, { rejectWithValue }) => {
    try {
      const response: any = await Axios.post(`${api.master.sub_category.addSubCategory}`, data);
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to add SubCategory");
    }
  }
);

export const deleteSubCategory = createAsyncThunk(
  "subcategory/delete",
  async (id: number, { rejectWithValue }) => {
    try {
      await Axios.delete(`${api.master.sub_category.deleteSubCategory}${id}/`);
      return id;
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

// export const exportSubCategoryCSV = async () => {
//   const response = await Axios.get("/subcategory/?export=csv", {
//     responseType: "blob",
//   });

//   return {
//     blob: response.data,
//     filename:
//       response.headers["content-disposition"]
//         ?.split("filename=")[1]
//         ?.replace(/"/g, "") || "subcategory.csv",
//   };
// };

export const exportSubCategoryCSV = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: any;
}) => {
  const params = new URLSearchParams();

  params.append("export", "excel");

  if (search) params.append("search", search);

   if (filters && filters.length > 0) {
      // params.append("filters", JSON.stringify(filters));
      filters.forEach(
        ({
          filterField,
          filterValue,
        }: {
          filterField: string;
          filterValue: any;
        }) => {
          if (
            filterField &&
            filterValue !== undefined &&
            filterValue !== null
          ) {
            if (typeof filterValue === "object" && filterValue !== null) {
                if (filterField === "created_at") {
                  if (filterValue.from_date) {
                    params.append("created_at_from", filterValue.from_date);
                  }
                  if (filterValue.to_date) {
                    params.append("created_at_to", filterValue.to_date);
                  }
                } else if (filterField === "updated_at") {
                  if (filterValue.from_date) {
                    params.append("updated_at_from", filterValue.from_date);
                  }
                  if (filterValue.to_date) {
                    params.append("updated_at_to", filterValue.to_date);
                  }
                } else {
                  // Handle other object filters
                  Object.entries(filterValue).forEach(([key, value]) => {
                    if (value !== undefined && value !== null && value !== "") {
                      params.append(key, String(value));
                    }
                  });
                }
              } else {
                // Handle primitive values (string, number)
                params.append(filterField, filterValue);
              }
          }
        }
      );
    }
  const response = await Axios.get(`/master/sub-category/?${params.toString()}`, {
    responseType: "blob",
  });

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "subcategory.csv",
  };
};
